import React from "react";
import { Link } from "react-router-dom";

const Footer = () => {
    return (
        <div className="mt-12 bg-primary-10 p-10 rounded-3xl">
            <div className="flex flex-col md:flex-row justify-between items-center">
                <div>
                    <img
                        src="/assets/trust-hospital-logo.png"
                        alt="Trust hospital logo"
                        className="w-40"
                    />
                </div>
                <div className="mt-8 md:mt-0">
                    <p className="text-primary-300 opacity-70 text-sm text-center md:text-right">
                        © {new Date().getFullYear()} The Trust Hospital. All rights reserved.
                    </p>
                    <div className="flex justify-center md:justify-end mt-2">
                        <Link to="/privacy-policy" className="text-primary-100 text-sm hover:underline">
                            Privacy Policy
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Footer; 